import { DOCX_TYPE, PDF_TYPE, PPTX_TYPE, XLSX_TYPE, ZIP_TYPE, TXT_TYPE, CSV_TYPE, RAR_TYPE } from 'utils/constants'
import { icons } from 'utils/icons'

export const getFileIcon = (mimetype: string) => {

  // Check for DOCX
  if (DOCX_TYPE.includes(mimetype)) {
    return icons.msWordIcon
  }

  // Check for PDF
  if (PDF_TYPE.includes(mimetype)) {
    return icons.pdfIcon
  }

  // Check for PPTX
  if (PPTX_TYPE.includes(mimetype)) {
    return icons.powerpointIcon
  }

  // Check for XLSX
  if (XLSX_TYPE.includes(mimetype)) {
    return icons.excelIcon
  }

  if (CSV_TYPE.includes(mimetype)) {
    return icons.csvIcon
  }

  // Check for ZIP
  if (ZIP_TYPE.includes(mimetype)) {
    return icons.zipIcon
  }

  // Check for RAR
  if (RAR_TYPE.includes(mimetype)) {
    return icons.rarIcon
  }

  // Check for audio files
  if (mimetype?.includes('audio')) {
    return icons.sendActiveRecordPlay
  }

  // Check for text files
  if (TXT_TYPE?.includes(mimetype)) {
    return icons.txtIcon
  }

  // Default fallback
  return icons.pdfIcon
}
